import React from 'react';
import { Box, Button, VStack, Text, HStack, useColorModeValue, Divider, Tooltip } from "@chakra-ui/react";
import { Link, useLocation } from 'react-router-dom';
import { FaUniversity, FaClipboardList, FaUserShield, FaBookOpen, FaTasks } from "react-icons/fa";
import PrivateSidebarLayout from '../Common/PrivateSidebarLayout';
import { usePlatformSidebar } from "../Common/PrivateSidebarContext";

const SuperuserSideBar = () => {
  const { isCollapsed } = usePlatformSidebar();
  const location = useLocation();

  const hoverBg = useColorModeValue("gray.100", "gray.700");

  const renderNavLink = (to: string, label: string, icon: React.ReactElement) => {
    const isActive = location.pathname === to;

    const button = (
      <Button
        as={Link}
        to={to}
        justifyContent={isCollapsed ? "center" : "flex-start"}
        variant="ghost"
        size="sm"
        pl={isCollapsed ? 0 : 4}
        py={5}
        borderRadius="lg"
        bg={isActive ? hoverBg : "transparent"}
        _hover={{ bg: hoverBg }}
        fontWeight={isActive ? "semibold" : "medium"}
        w="100%"
      >
        <HStack spacing={isCollapsed ? 0 : 3}>
          {icon}
          {!isCollapsed && <Text fontSize="sm">{label}</Text>}
        </HStack>
      </Button>
    );

    return isCollapsed ? (
      <Tooltip label={label} placement="right" hasArrow>
        {button}
      </Tooltip>
    ) : button;
  };

  return (
    <PrivateSidebarLayout>
      <Box px={isCollapsed ? 1 : 3} py={4} mt={10}>
        <VStack align="stretch" spacing={1}>
          {renderNavLink(`/platform/super/tenant-manager`, "Tenant Manager", <FaUniversity />)}
          <Divider my={1} />
          {renderNavLink(`/platform/super/subscription-manager`, "Subscriptions", <FaClipboardList />)}
          <Divider my={1} />
          {renderNavLink(`/platform/super/admin-manager`, "Admin Manager", <FaUserShield />)}
          <Divider my={1} />
          {renderNavLink(`/platform/super/course-manager`, "Course Manager", <FaBookOpen />)}
          <Divider my={1} />
          {renderNavLink(`/platform/super/scheduler-jobs`, "Scheduler Jobs", <FaTasks />)}
        </VStack>
      </Box>
    </PrivateSidebarLayout>
  );
};

export default SuperuserSideBar;